import React from 'react';
import ReactDOM from 'react-dom';
import LotItem from './LotItem';
import BaseComponent from '../../../general/js/base-component';

export default class LotItemComponent extends BaseComponent {
    constructor() {
        super(...arguments);

        this.item = this.options.item;
        this.init();
    }

    init() {
        ReactDOM.render(<LotItem item={this.item}/>, this.element);
    }
}



// WEBPACK FOOTER //
// ./app/components/lot-item/js/lot-item.component.js